export type AccordionBadgeKind =
  | "validationError"
  | "validationSuccess"
  | "selectPaymentLocation"
  | "selectAddressAndTime"
  | "noPackingList"
  | "selectFreightMode"
  | "setDeadlinesAndProviders"
  | null;

type ResolveAccordionBadgeArgs = {
  sectionKey: string;
  hasValidationError: boolean;
  hasAttemptedReview: boolean;
  hasPaymentLocation: boolean;
  hasScheduleAddresses: boolean;
  hasPackingList: boolean;
  hasFreightMode: boolean;
  hasDeadlinesAndProviders: boolean;
};

export function resolveAccordionBadge({
  sectionKey,
  hasValidationError,
  hasAttemptedReview,
  hasPaymentLocation,
  hasScheduleAddresses,
  hasPackingList,
  hasFreightMode,
  hasDeadlinesAndProviders,
}: ResolveAccordionBadgeArgs): AccordionBadgeKind {
  const isOrganisation = sectionKey === "request-form.organisation";

  if (hasValidationError) {
    return "validationError";
  }

  if (hasAttemptedReview && (isOrganisation || hasPaymentLocation)) {
    return "validationSuccess";
  }

  if (!isOrganisation && !hasPaymentLocation) {
    return "selectPaymentLocation";
  }

  if (!hasPaymentLocation || hasAttemptedReview) {
    return null;
  }

  if (sectionKey === "request-form.schedule" && !hasScheduleAddresses) {
    return "selectAddressAndTime";
  }

  if (sectionKey === "request-form.packingList" && !hasPackingList) {
    return "noPackingList";
  }

  if (sectionKey === "request-form.service" && !hasFreightMode) {
    return "selectFreightMode";
  }

  if (sectionKey === "request-form.provider" && !hasDeadlinesAndProviders) {
    return "setDeadlinesAndProviders";
  }

  return null;
}
